import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { fetchingAllCriteria, fetchingAllUseCase, fetchingBeforePackExpiry } from "../redux/Actions";
import AccordianComponent from "./AccordianComponent";
import EMSwitch from "./EMSwitch";
import {accordianEnumArray} from '../constants'

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
    // position: "absolute",
    // float: "right",
    // marginLeft: "47rem"
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },

  
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "0px solid rgba(0, 0, 0, .125)",
}));

export default function Accordian(props) {
  const dispatch = useDispatch();
  var allpack = useSelector((state) => state?.sns);
  const [expanded, setExpanded] = React.useState("");
  const [originalData, setOriginalData] = React.useState([])
  // const [inputValue, setInputValue] = React.useState("");
  // const [periodicity, setPeriodicity] = React.useState("");

  const [isChecked, setChecked] = React.useState();

  const isCheckedOnHandler = (key, config) => {
    if (key) {
      setChecked((prevStates) => ({
        ...prevStates,
        [key]: !prevStates[key],
      }));

      if (key && allpack) {
        // let config =  allpack?.allpack.reduce((acc, key) => ({ ...acc }))
        let body = {
          method: "put",
          usecaseProfileName: config.usecaseProfileName,
          isEnable: !isChecked[key], // config.isEnable,
          periodicity: config.periodicity,
          duration: config.duration,
          totalNotification: config.totalNotification,
          tsHours: config.tsHours,
          tsMinutes: config.tsMinutes,
          endHours: null,
          endMinutes: null,
          messageText: config.messageText, //"Dear user, your Super Plan subscription pack is set to expire on <EXPIRY_DATE>. Kindly recharge your pack to continue enjoying uninterrupted services.",
          landingPoints: config.landingPoints, //["Point1", "Point2"],
          usecaseDisplayName: config.usecaseDisplayName, //"Send notification before pack expiry."
          usecaseId: config.usecaseId,
          startDays:config?.startDays,
          weekDays:config.weekDays,
          userSegmentCriteria:config.userSegmentCriteria,
          operators: config.operators?config.operators:[]
        };

        dispatch(fetchingBeforePackExpiry(body));
        setTimeout(() => {
          dispatch(fetchingAllUseCase());
        }, 500);
      }
    }
  };

  const handleChange = (panel, res) => (e, newExpanded) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (e.target.type === "checkbox") {
      isCheckedOnHandler(panel, res);
    } else {
      // res.isEnable && setExpanded(newExpanded ? panel : false);
    }
  };

  const handleAccordiaChange = (panel, res) => (e, newExpanded) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (e.target.type === "checkbox") {
      isCheckedOnHandler(panel, res);
    } else {
      res.isEnable && setExpanded(newExpanded ? panel : false);
    }
  };


  React.useEffect(() => {
    dispatch(fetchingAllUseCase());
    dispatch(fetchingAllCriteria());

  }, [dispatch]);

  React.useEffect(() => {
    setChecked(
      allpack?.allpack.reduce(
        (acc, key) => ({ ...acc, [key.usecaseId]: key.isEnable }),
        {}
      )
    );
     }, [allpack?.allpack, isChecked]);


  return (
    <div>
      <div>
        {allpack?.allpack &&
          allpack?.allpack.map((res, index) => {
            return (
              <Accordion
                expanded={res.isEnable && (expanded === res.usecaseId)}
                onChange={handleAccordiaChange(res.usecaseId, res)}
              >
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <Typography>
                    {res.userProfileHeader}
                  </Typography>
                  {
                    <EMSwitch
                      sx={{ m: 1 }}
                      usecaseProfileName={res && res.usecaseProfileName}
                      onChange={handleChange(
                        isChecked ? res.usecaseId : res.isEnable,
                        res
                      )}
                      checked={
                        isChecked ? isChecked[res.usecaseId] : res.isEnable
                      }
                      expanded={res.isEnable && (expanded === res.usecaseId)}
                    />
                  }
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    marginTop: "10px",
                    display: res.isEnable ? "block" : "none",
                  }}
                >
                  <AccordianComponent criteria={allpack?.allCriteria} packdata={res} checkboxdata={isChecked} expanded={expanded} />
                </AccordionDetails>
              </Accordion>
            );
          })}
      </div>
    </div>
  );
}
